import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
// Importar traducciones
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';

// Limpiar localStorage para evitar conflictos con idiomas guardados previamente
// Solo en desarrollo para facilitar las pruebas
if (process.env.NODE_ENV === 'development') {
  localStorage.removeItem('i18nextLng');
}

// Los recursos de traducción
const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  }
};

i18n
  // Detectar idioma del navegador
  .use(LanguageDetector)
  // Pasar el módulo i18n a react-i18next
  .use(initReactI18next)
  // Inicializar i18next
  .init({
    resources,
    fallbackLng: 'en', // Idioma por defecto si no se detecta ninguno
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // No es necesario para React
    },
    detection: {
      // Orden de detección de idioma (cambiado para dar prioridad a la URL)
      order: ['querystring', 'path', 'localStorage', 'navigator', 'htmlTag'],
      // Parámetros de URL para el idioma
      lookupQuerystring: 'lng',
      lookupFromPathIndex: 0,
      // Solo usar estos idiomas (si detecta otros, usará el fallback)
      supportedLngs: ['en', 'es'],
      // Guardar el idioma en localStorage
      caches: ['localStorage']
    }
  });

// Para depuración
if (process.env.NODE_ENV === 'development') {
  // Mostrar en consola el idioma actual
  console.log('Current language:', i18n.language);
}

export default i18n; 